module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAABPklEQVQokY3QsavNYRzH8dc59+Qq3cKoJMY7yMkgkQyfUkaDjTLKbsLoD7gMd7AwGCwmpX7f5A6Kxc1gUFbS7Z4UJYZzj8Hz4w4O97s9z/P+fp/39zPouu4lTthZrY8avII1DOaAM4xxY9QuHiZ59a/RVbWO68N2PrADnYOYDf+L/akNLPZK89x7nXM4jQ9DTDGtqptVdeYv8H08xRImvdIGjmCtqq41cKmq3uMyjuM2lodYwN4kV3AVd6vqBb7gK3YneY1lbPU/7IEkqzjmV2qrScZJfjRmC7N+6WnvnOQNDs8LoG/4HW9VLeI59uFUkkl7WtgObjb4PL43xc/YrKpLjfmIXUN8w6iq7uAJVpIcTXISt/Cgqh5hPz4Nuq6btQkTXEzybLtzVY3xGIdg0HXdO7xNcmHeoq3xHs7+BNJOaS6cc+1bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/29.png
// module id = CG+3
// module chunks = 0